import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../../common/components/header/header";

function Home() {
  const location = useLocation();
  // if (location.pathname === '/home') {
  //   return <Navigate to="deals" replace={true} />; // Redirect to "deals"
  // }
  // if (window.location.href.indexOf("/ebix-portal-web/?order_no") > -1) {
  //   const base_url = window.location.origin;
  //   const url: URL = new URL(window.location.href);
  //   const params: URLSearchParams = url.searchParams;
  //   const order_no = params.get('order_no');
  //   const sessionId = params.get('session_id');
  //   const referencenumber = params.get('reference_number');
  //   window.location.href= base_url +'/ebix-portal-web/#/home/payment-status?order_no='+order_no+'&sessionId='+sessionId+'&reference_number='+referencenumber
  // }
  return (
    <div style={{ height: '100vh', background: '#F5F5F7', width: '100%', overflowY: 'auto' }}>
      <Header></Header>
      <Outlet></Outlet>
    </div>
  );

}
export default Home;